import { useEffect, useRef, useState } from 'react';
import * as PIXI from 'pixi.js';
import AssetsLoader from '../../features/gameplay/utils/assetsLoader';
import { useApi } from '../../services/api/ApiProvider';

import CardHighlightFilter from '../../features/gameplay/filters/CardHighlightFilter';
import CardContainer from '../../features/gameplay/containers/cardContainer';
import { convertToVec3, CARD_HEIGHT, CARD_WIDTH } from '../../features/gameplay/utils/commonUtils';

import giveDonFragmentShaderSrc from './giveDon2.frag';
import giveDonVertexShaderSrc from './vertex.vert';

const leaderCardInstance = {
    "instanceId": "inst_1746715844767_zumea",
    "baseCardId": "ST01-001",
    "ownerPlayerId": "KIJFvN51oev_AjZbAAAH",
    "isRested": false,
    "isBlocker": true,
    "attachedDon": [],
    "currentPower": 5000,
    "location": "field_characters",
    "turnPlayed": -1,
    "baseData": {
        "id": "ST01-001",
        "alternateArts": [],
        "name": "Monkey.D.Luffy",
        "type": "Leader",
        "attribute": "Strike",
        "effectText": "[Activate: Main] [Once Per Turn] Give this Leader or 1 of your Characters up to 1 rested DON!! card.",
        "imgUrl": "https://en.onepiece-cardgame.com/images/cardlist/card/ST01-001.png?230630",
        "power": 5000,
        "cost": null,
        "life": 5,
        "counter": null,
        "color": [
            "Red"
        ],
        "cardTraits": [
            "Supernovas",
            "Straw Hat Crew"
        ],
        "rarity": "L"
    },
    "detailedEffects": [
        {
            "trigger": "ActivateMain",
            "restriction": "OncePerTurn",
            "description": "[Activate: Main] [Once Per Turn] Give this Leader or 1 of your Characters up to 1 rested DON!! card.",
            "preConditions": [
                {
                    "check": "hasRestedDon",
                    "zone": "CostArea",
                    "count": 1
                }
            ],
            "version": 2,
            "effectSteps": [
                {
                    "stepId": "chooseRecipient",
                    "type": "target",
                    "targetCriteria": {
                        "scope": "Player",
                        "zone": [
                            "Leader",
                            "FieldCharacters"
                        ],
                        "maxTargets": 1,
                        "optional": false,
                        "filters": []
                    }
                },
                {
                    "stepId": "action",
                    "type": "action",
                    "actionType": "AttachDonV2",
                    "details": {
                        "targetCardStepIdRef": "chooseRecipient",
                        "isRested": true,
                        "count": 1
                    }
                }
            ],
            "targetSteps": [
                {
                    "stepId": "chooseRecipient",
                    "scope": "Player",
                    "zone": [
                        "Leader",
                        "FieldCharacters"
                    ],
                    "maxTargets": 1,
                    "optional": false,
                    "filters": [],
                    "prompt": "Choose Leader or Character to receive DON!!"
                },
                {
                    "stepId": "chooseDon",
                    "scope": "Player",
                    "zone": "CostArea",
                    "maxTargets": 1,
                    "optional": true,
                    "filters": [
                        {
                            "field": "isRested",
                            "comparison": "eq",
                            "value": true
                        }
                    ],
                    "prompt": "Choose 1 Rested DON!! from your Cost Area"
                }
            ],
            "action": {
                "type": "AttachDon",
                "details": {
                    "donInstanceIdRef": "chooseDon",
                    "targetCardIdRef": "chooseRecipient"
                }
            }
        }
    ],
    "name": "Monkey.D.Luffy",
    "type": "Leader",
    "cost": null,
    "power": 5000,
    "life": 5,
    "counter": null,
    "attribute": "Strike",
    "color": [
        "Red"
    ],
    "cardTraits": [
        "Supernovas",
        "Straw Hat Crew"
    ],
    "effectText": "[Activate: Main] [Once Per Turn] Give this Leader or 1 of your Characters up to 1 rested DON!! card.",
    "imgUrl": "https://en.onepiece-cardgame.com/images/cardlist/card/ST01-001.png?230630",
    "hasRush": false
};

export default function ShadersDemoPage() {
    const pixiContainerRef = useRef(null);
    const pixiAppRef = useRef(null);
    const bloomFilterRef = useRef(null);

    const [borderStrength, setBorderStrength] = useState(CardHighlightFilter.initialValues.borderStrength);
    const [borderSize, setBorderSize] = useState(CardHighlightFilter.initialValues.borderSize);
    const [effectStrength, setEffectStrength] = useState(CardHighlightFilter.initialValues.effectStrength);
    const [effectColor, setEffectColor] = useState(CardHighlightFilter.initialValues.effectColor);

    const [bloomStrength, setBloomStrength] = useState(0.5);
    const [bloomThreshold, setBloomThreshold] = useState(0.5);

    const api = useApi();


    useEffect(() => {
        const initGame = async () => {
            if (!pixiAppRef.current && pixiContainerRef.current) {
                await Promise.all([...(await document.fonts.ready)].map(font => font.load()));

                const app = new PIXI.Application();
                await app.init({
                    width: 800,
                    height: 600,
                    backgroundColor: 0x1099bb,
                    antialias: true,
                });

                await AssetsLoader.init();

                const deckAssets1 = await api.fetchDeckAssets('ST01');
                // const deckAssets2 = await api.fetchDeckAssets('ST04');

                await AssetsLoader.loadDecks([deckAssets1]);

                pixiAppRef.current = app;
                window.globalThis.__PIXI_APP__ = app;

                pixiContainerRef.current.appendChild(app.canvas);

                const going_merry_texture = await PIXI.Assets.load('/assets/going_marry.png');
                const going_merry_sprite = new PIXI.Sprite(going_merry_texture);
                going_merry_sprite.anchor.set(0.5);
                going_merry_sprite.x = 400;
                going_merry_sprite.y = 582.5;
                going_merry_sprite.scale.set(1.1);
                app.stage.addChild(going_merry_sprite);

                const cardContainer = new CardContainer(leaderCardInstance);
                cardContainer.label = 'cardContainer';
                cardContainer.x = 400;
                cardContainer.y = 427;
                cardContainer.scale.set(0.9);
                cardContainer.highlightCard();
                // cardContainer.getChildByLabel('cardInnerFrame').visible = true;
                app.stage.addChild(cardContainer);

                // const ozFilterGlProgram = PIXI.GlProgram.from({ fragment: giveDonFragmentShaderSrc, vertex: giveDonVertexShaderSrc, name: 'give_don' });
                // const ozFIlter = new PIXI.Filter({ glProgram: ozFilterGlProgram, resources: { timeUniforms: { iTime: { value: 0.0, type: 'f32' } } } });
                // const rect = new PIXI.Graphics();
                // rect.label = 'rect';
                // rect.rect(-200, -200, 400, 400);
                // rect.fill({ color: '#ffffff' });
                // rect.x = 400;
                // rect.y = 427 - CARD_HEIGHT/2;
                // rect.filters = [ozFIlter, new PIXI.AlphaFilter()];
                // app.stage.addChild(rect);

                // app.ticker.add((tricker) => {
                //     ozFIlter.resources.timeUniforms.uniforms.iTime += tricker.deltaTime * 0.01;
                // });

                // const particleContainer = new PIXI.ParticleContainer();
                // particleContainer.x = 400;
                // particleContainer.y = 427 - CARD_HEIGHT/2;
                // const particleCircle = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.PARTICLE_CIRCLE);
                // const particle = new PIXI.Particle({ texture: particleCircle, anchorX: 0.5, anchorY: 0.5 });
                // particleContainer.addParticle(particle);
                // app.stage.addChild(particleContainer);

                app.stage.scale.set(0.55);
            }
        }
        initGame();

        return () => {
            if (pixiAppRef.current) {
                pixiAppRef.current.destroy(true, { children: true, texture: true, baseTexture: true });
                pixiAppRef.current = null;
            }
        }
    }, []);
    
    useEffect(() => {
        if (!pixiAppRef.current) {
            return;
        }

        const cardContainer = pixiAppRef.current.stage.getChildByLabel('cardContainer');
        const cardVisualsContainer = cardContainer.getChildByLabel('cardVisualsContainer');
        const cardHighlight = cardVisualsContainer?.getChildByLabel('cardHighlight');
        const cardHighlightFilter = cardHighlight?.filters[0];
        if (cardHighlightFilter) {
            cardHighlightFilter.resources.effectUniforms.uniforms.uBorderStrength = borderStrength;
        }
    }, [borderStrength]);

    useEffect(() => {
        if (!pixiAppRef.current) {
            return;
        }

        const cardContainer = pixiAppRef.current.stage.getChildByLabel('cardContainer');
        const cardVisualsContainer = cardContainer.getChildByLabel('cardVisualsContainer');
        cardVisualsContainer?.getChildByLabel('cardHighlight').scale.set(borderSize, borderSize*(65/62));
        cardVisualsContainer?.getChildByLabel('blockerFrameHighlightMask').scale.set(borderSize);
    }, [borderSize]);

    useEffect(() => {
        if (!pixiAppRef.current) {
            return;
        }

        const cardContainer = pixiAppRef.current.stage.getChildByLabel('cardContainer');
        const cardVisualsContainer = cardContainer.getChildByLabel('cardVisualsContainer');
        const cardHighlight = cardVisualsContainer?.getChildByLabel('cardHighlight');
        const cardHighlightFilter = cardHighlight?.filters[0];
        if (cardHighlightFilter) {
            cardHighlightFilter.resources.effectUniforms.uniforms.uEffectStrength = effectStrength;
        }
    }, [effectStrength]);

    useEffect(() => {
        if (!pixiAppRef.current) {
            return;
        }

        const cardContainer = pixiAppRef.current.stage.getChildByLabel('cardContainer');
        const cardVisualsContainer = cardContainer.getChildByLabel('cardVisualsContainer');
        const cardHighlight = cardVisualsContainer?.getChildByLabel('cardHighlight');
        const cardHighlightFilter = cardHighlight?.filters[0];
        if (cardHighlightFilter) {
            cardHighlightFilter.resources.effectUniforms.uniforms.uEffectColor = convertToVec3(effectColor);
        }
    }, [effectColor]);

    const handleSetHighlightPlayable = () => {
        if (!pixiAppRef.current) {
            return;
        }
        const cardContainer = pixiAppRef.current.stage.getChildByLabel('cardContainer');
        cardContainer.setHighlightPlayable();
    }

    const handleSetHighlightSelectable = () => {
        if (!pixiAppRef.current) {
            return;
        }
        const cardContainer = pixiAppRef.current.stage.getChildByLabel('cardContainer');
        cardContainer.setHighlightSelectable();
    }

    const handleSetHighlightSelected = () => {
        if (!pixiAppRef.current) {
            return;
        }
        const cardContainer = pixiAppRef.current.stage.getChildByLabel('cardContainer');
        cardContainer.setHighlightSelected();
    }

    const handleSetHighlightAttackTarget = () => {
        if (!pixiAppRef.current) {
            return;
        }
        const cardContainer = pixiAppRef.current.stage.getChildByLabel('cardContainer');
        cardContainer.setHighlightAttackTarget();
    }

    const handleUnhighlightCard = () => {
        if (!pixiAppRef.current) {
            return;
        }
        const cardContainer = pixiAppRef.current.stage.getChildByLabel('cardContainer');
        cardContainer.unhighlightCard();
    }

    return (
        <div>
            <h1>Shaders Demo</h1>
            <div>
                <span>Border Strength</span>
                <input type="range" min="0" max="5" step="0.01" value={borderStrength} onChange={(e) => setBorderStrength(e.target.value)} />
                <span>{borderStrength}</span>
            </div>
            <div>
                <span>Border Size</span>
                <input type="range" min="0" max="2" step="0.01" value={borderSize} onChange={(e) => setBorderSize(e.target.value)} />
                <span>{borderSize}</span>
            </div>
            <div>
                <span>Effect Strength</span>
                <input type="range" min="0" max="5" step="0.01" value={effectStrength} onChange={(e) => setEffectStrength(e.target.value)} />
                <span>{effectStrength}</span>
            </div>
            <div>
                <span>Effect Color</span>
                <input type="color" value={effectColor} onChange={(e) => setEffectColor(e.target.value)} />
                <span>{effectColor}</span>
            </div>
            <div>
                <span>Restart Animation</span>
                <button onClick={() => {
                    if (!pixiAppRef.current) {
                        return;
                    }
                    const rect = pixiAppRef.current.stage.getChildByLabel('rect');
                    if (rect) {
                        rect.filters[0].resources.timeUniforms.uniforms.iTime = 0.0;
                    }
                }}>Restart</button>
            </div>
            <div><button onClick={handleSetHighlightPlayable}>set highlight playable</button></div>
            <div><button onClick={handleSetHighlightSelectable}>set highlight selectable</button></div>
            <div><button onClick={handleSetHighlightSelected}>set highlight selected</button></div>
            <div><button onClick={handleSetHighlightAttackTarget}>set highlight attack target</button></div>
            <div><button onClick={handleUnhighlightCard}>unhighlight card</button></div>
            <div ref={pixiContainerRef} />
        </div>
    );
}
